<template>
  <div class="aliexpress-store">
    <!-- Top bar gris -->
    <div class="top-bar">
      <div class="container">
        <div class="top-links">
          <a href="#">🇵🇪 Envíos a Perú</a>
          <a href="#">📦 Seguimiento</a>
          <a href="#">💬 Ayuda</a>
          <a href="#">👤 Mi cuenta</a>
          <a href="#">⭐ Opiniones</a>
        </div>
      </div>
    </div>

    <!-- Header principal -->
    <div class="main-header">
      <div class="container">
        <div class="header-row">
          <!-- Logo -->
          <div class="logo" @click="goBack">
            <span class="logo-icon">🔧</span>
            <span class="logo-text">Auto<span class="logo-orange">Parts</span></span>
          </div>

          <!-- Buscador -->
          <div class="search-wrapper">
            <div class="search-box">
              <input
                type="text"
                v-model="searchTerm"
                @keyup.enter="buscarProductos"
                placeholder="Buscar productos... ej: aceite, frenos, filtros"
                class="search-input"
              />
              <button class="search-btn" @click="buscarProductos">🔍 Buscar</button>
            </div>
          </div>

          <!-- Zona derecha vacía para balance -->
          <div class="header-right"></div>
        </div>
      </div>
    </div>

    <!-- Categorías -->
    <div class="categories-bar">
      <div class="container">
        <div class="categories-list">
          <div
            v-for="cat in categorias"
            :key="cat.nombre"
            class="category-item"
            @click="filtrarPorCategoria(cat.nombre)"
          >
            <span class="cat-icon">{{ cat.icono }}</span>
            <span>{{ cat.nombre }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Banner hero -->
    <div class="hero-banner">
      <div class="container">
        <div class="hero-content">
          <div class="hero-text">
            <span class="hero-badge">🔥 OFERTA DEL DÍA</span>
            <h1>Hasta 40% OFF</h1>
            <p>En aceites, filtros y lubricantes</p>
            <button class="hero-btn" @click="scrollToProductos">Comprar ahora →</button>
          </div>
          <div class="hero-stats">
            <div class="stat">⚡ 24h de envío</div>
            <div class="stat">🛡️ Garantía</div>
            <div class="stat">💰 Mejor precio</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Productos -->
    <div id="productos" class="products-section">
      <div class="container">
        <div class="section-header">
          <h2>⚡ Más vendidos</h2>
          <a href="#" class="see-all">Ver todos →</a>
        </div>

        <div v-if="productosFiltrados.length === 0" class="no-results">
          <p>No se encontraron productos</p>
          <button @click="limpiarBusqueda">Limpiar</button>
        </div>

        <div v-else class="products-grid">
          <div
            v-for="producto in productosFiltrados"
            :key="producto.id"
            class="product-card"
          >
            <div v-if="producto.oferta" class="product-badge">
              -{{ producto.descuento }}%
            </div>
            <div class="product-img">📦</div>
            <div class="product-info">
              <h3>{{ producto.nombre }}</h3>
              <div class="price-row">
                <span class="current-price">S/ {{ producto.precio }}</span>
                <span v-if="producto.precio_anterior" class="old-price"
                  >S/ {{ producto.precio_anterior }}</span
                >
              </div>
              <div class="rating">
                ★★★★★ <span>({{ producto.reviews }})</span>
              </div>
              <div class="shipping">🚚 Envío gratis</div>
              <button class="add-btn" @click="agregarAlCarrito(producto)">
                🛒 Agregar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Marcas -->
    <div class="brands-section">
      <div class="container">
        <div class="brands-grid">
          <div v-for="marca in marcas" :key="marca" class="brand-item">{{ marca }}</div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="footer">
      <div class="container">
        <div class="footer-grid">
          <div>
            <h4>AutoParts</h4>
            <p>Tu tienda de confianza</p>
          </div>
          <div>
            <h4>Enlaces</h4>
            <a href="#">Términos</a>
            <a href="#">Privacidad</a>
            <a href="#">Contacto</a>
          </div>
          <div>
            <h4>Contacto</h4>
            <p>📞 +51 928 180 748</p>
            <p>✉️ ventas@autoparts.com</p>
          </div>
        </div>
        <div class="footer-bottom">
          <p>© 2024 AutoParts - Todos los derechos reservados</p>
        </div>
      </div>
    </div>

    <!-- ========== CARRITO FLOTANTE (esquina inferior derecha) ========== -->
    <div class="cart-floating" @click="verCarrito">
      <div class="cart-icon-big">
        🛒
        <span class="cart-badge-big">{{ carrito.length }}</span>
      </div>
      <div class="cart-total-preview">S/ {{ totalCarrito }}</div>
    </div>

    <!-- Modal carrito -->
    <div v-if="mostrarCarrito" class="modal-overlay" @click.self="cerrarCarrito">
      <div class="modal-container">
        <div class="modal-header">
          <h3>🛒 Mi carrito ({{ carrito.length }})</h3>
          <button class="modal-close" @click="cerrarCarrito">✕</button>
        </div>
        <div class="modal-body">
          <div v-if="carrito.length === 0" class="empty-cart-modal">
            <div>🛍️</div>
            <p>Tu carrito está vacío</p>
            <button class="btn-continue" @click="cerrarCarrito">Seguir comprando</button>
          </div>
          <div v-else>
            <div v-for="(item, idx) in carrito" :key="item.id" class="cart-item-row">
              <div class="cart-item-info">
                <div class="cart-item-name">{{ item.nombre }}</div>
                <div class="cart-item-price">S/ {{ item.precio }}</div>
              </div>
              <div class="cart-item-actions">
                <button class="qty-btn" @click="disminuirCantidad(idx)">-</button>
                <span class="qty-num">{{ item.cantidad }}</span>
                <button class="qty-btn" @click="aumentarCantidad(idx)">+</button>
                <button class="remove-item" @click="eliminarDelCarrito(idx)">🗑️</button>
              </div>
              <div class="cart-item-subtotal">S/ {{ item.precio * item.cantidad }}</div>
            </div>
            <div class="cart-total-section">
              <span>Total:</span>
              <strong>S/ {{ totalCarrito }}</strong>
            </div>
            <button class="btn-checkout" @click="irAPagar">Finalizar compra →</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal pago -->
    <div v-if="mostrarPago" class="modal-overlay" @click.self="cerrarPago">
      <div class="modal-container modal-pago">
        <div class="modal-header">
          <h3>💳 Finalizar compra</h3>
          <button class="modal-close" @click="cerrarPago">✕</button>
        </div>
        <div class="modal-body">
          <div class="order-resumen">
            <div v-for="item in carrito" :key="item.id" class="order-line">
              <span>{{ item.nombre }} x {{ item.cantidad }}</span>
              <span>S/ {{ item.precio * item.cantidad }}</span>
            </div>
            <div class="order-total-line">
              <strong>Total a pagar:</strong>
              <strong class="total-amount">S/ {{ totalCarrito }}</strong>
            </div>
          </div>
          <input
            type="text"
            v-model="pago.nombre"
            placeholder="Nombre completo"
            class="input-field"
          />
          <input
            type="text"
            v-model="pago.direccion"
            placeholder="Dirección de envío"
            class="input-field"
          />
          <input
            type="text"
            v-model="pago.telefono"
            placeholder="Teléfono"
            class="input-field"
          />
          <select v-model="pago.metodo" class="input-field">
            <option value="tarjeta">💳 Tarjeta de crédito/débito</option>
            <option value="yape">📱 Yape</option>
            <option value="plin">📱 Plin</option>
            <option value="contraentrega">🚚 Contra entrega</option>
          </select>
          <button class="btn-pay" @click="confirmarPago">Confirmar pago</button>
        </div>
      </div>
    </div>

    <!-- Toast -->
    <div v-if="toastVisible" class="toast-notification">
      {{ toastMensaje }}
    </div>
  </div>
</template>

<script>
export default {
  name: "AutopartsStore",
  data() {
    return {
      searchTerm: "",
      mostrarCarrito: false,
      mostrarPago: false,
      toastVisible: false,
      toastMensaje: "",
      carrito: [],
      pago: { nombre: "", direccion: "", telefono: "", metodo: "tarjeta" },
      categorias: [
        { nombre: "Motores", icono: "⚙️" },
        { nombre: "Frenos", icono: "🛑" },
        { nombre: "Suspensión", icono: "🔧" },
        { nombre: "Neumáticos", icono: "🛞" },
        { nombre: "Aceites", icono: "🛢️" },
        { nombre: "Filtros", icono: "🌀" },
        { nombre: "Luces", icono: "💡" },
        { nombre: "Accesorios", icono: "🎨" },
      ],
      productos: [
        {
          id: 1,
          nombre: "Aceite de Motor 5W30 Sintético",
          precio: 89,
          precio_anterior: 120,
          oferta: true,
          descuento: 26,
          rating: 4.8,
          reviews: 156,
        },
        {
          id: 2,
          nombre: "Pastillas de Freno Delanteras",
          precio: 159,
          precio_anterior: null,
          oferta: false,
          rating: 4.7,
          reviews: 89,
        },
        {
          id: 3,
          nombre: "Filtro de Aire Alta Performance",
          precio: 45,
          precio_anterior: 65,
          oferta: true,
          descuento: 31,
          rating: 4.9,
          reviews: 203,
        },
        {
          id: 4,
          nombre: "Batería 12V Libre Mantenimiento",
          precio: 299,
          precio_anterior: null,
          oferta: false,
          rating: 4.6,
          reviews: 78,
        },
        {
          id: 5,
          nombre: "Amortiguadores Traseros",
          precio: 189,
          precio_anterior: 250,
          oferta: true,
          descuento: 24,
          rating: 4.8,
          reviews: 112,
        },
        {
          id: 6,
          nombre: "Lámparas LED Kit Completo",
          precio: 79,
          precio_anterior: null,
          oferta: false,
          rating: 4.7,
          reviews: 167,
        },
        {
          id: 7,
          nombre: "Líquido de Frenos DOT4",
          precio: 35,
          precio_anterior: 50,
          oferta: true,
          descuento: 30,
          rating: 4.9,
          reviews: 94,
        },
        {
          id: 8,
          nombre: "Correa de Distribución",
          precio: 129,
          precio_anterior: null,
          oferta: false,
          rating: 4.8,
          reviews: 145,
        },
      ],
      marcas: [
        "BOSCH",
        "MOBIL",
        "CASTROL",
        "BRIDGESTONE",
        "MICHELIN",
        "NGK",
        "TOTAL",
        "SHELL",
      ],
    };
  },
  computed: {
    productosFiltrados() {
      if (!this.searchTerm) return this.productos;
      const term = this.searchTerm.toLowerCase();
      return this.productos.filter((p) => p.nombre.toLowerCase().includes(term));
    },
    totalCarrito() {
      return this.carrito.reduce((t, i) => t + i.precio * i.cantidad, 0);
    },
  },
  methods: {
    goBack() {
      window.location.href = "/portafolio";
    },
    scrollToProductos() {
      document.getElementById("productos").scrollIntoView({ behavior: "smooth" });
    },
    buscarProductos() {
      if (this.searchTerm) this.scrollToProductos();
    },
    limpiarBusqueda() {
      this.searchTerm = "";
    },
    filtrarPorCategoria(cat) {
      this.showToast(`📂 Categoría: ${cat}`);
    },
    agregarAlCarrito(p) {
      const exist = this.carrito.find((i) => i.id === p.id);
      if (exist) exist.cantidad++;
      else this.carrito.push({ ...p, cantidad: 1 });
      this.showToast(`✅ ${p.nombre} agregado`);
    },
    aumentarCantidad(i) {
      this.carrito[i].cantidad++;
    },
    disminuirCantidad(i) {
      if (this.carrito[i].cantidad > 1) this.carrito[i].cantidad--;
      else this.eliminarDelCarrito(i);
    },
    eliminarDelCarrito(i) {
      const removed = this.carrito[i];
      this.carrito.splice(i, 1);
      this.showToast(`🗑️ ${removed.nombre} eliminado`);
    },
    verCarrito() {
      this.mostrarCarrito = true;
    },
    cerrarCarrito() {
      this.mostrarCarrito = false;
    },
    irAPagar() {
      this.mostrarCarrito = false;
      this.mostrarPago = true;
    },
    cerrarPago() {
      this.mostrarPago = false;
    },
    confirmarPago() {
      if (!this.pago.nombre || !this.pago.direccion) {
        this.showToast("⚠️ Completa tus datos");
        return;
      }
      this.showToast(`🎉 ¡Gracias ${this.pago.nombre}! Compra exitosa`);
      setTimeout(() => {
        this.carrito = [];
        this.mostrarPago = false;
        this.pago = { nombre: "", direccion: "", telefono: "", metodo: "tarjeta" };
      }, 2000);
    },
    showToast(msg) {
      this.toastMensaje = msg;
      this.toastVisible = true;
      setTimeout(() => {
        this.toastVisible = false;
      }, 3000);
    },
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.aliexpress-store {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif;
  background: #f5f5f5;
  min-height: 100vh;
  position: relative;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* Top bar */
.top-bar {
  background: #1a1a1a;
  padding: 8px 0;
  font-size: 12px;
}
.top-links {
  display: flex;
  gap: 25px;
  justify-content: flex-end;
}
.top-links a {
  color: #aaa;
  text-decoration: none;
}
.top-links a:hover {
  color: #ff6f00;
}

/* Header */
.main-header {
  background: white;
  padding: 20px 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.header-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 30px;
}
.logo {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  min-width: 180px;
}
.logo-icon {
  font-size: 32px;
}
.logo-text {
  font-size: 24px;
  font-weight: bold;
}
.logo-orange {
  color: #ff6f00;
}

/* Search */
.search-wrapper {
  flex: 1;
  max-width: 500px;
}
.search-box {
  display: flex;
  border: 2px solid #ff6f00;
  border-radius: 8px;
  overflow: hidden;
  background: white;
}
.search-input {
  flex: 1;
  padding: 12px 16px;
  border: none;
  outline: none;
  font-size: 14px;
}
.search-btn {
  background: #ff6f00;
  color: white;
  border: none;
  padding: 12px 24px;
  cursor: pointer;
  font-weight: bold;
}
.header-right {
  min-width: 180px;
}

/* Categories bar */
.categories-bar {
  background: white;
  border-bottom: 1px solid #e0e0e0;
  padding: 12px 0;
}
.categories-list {
  display: flex;
  gap: 30px;
  flex-wrap: wrap;
}
.category-item {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding: 5px 10px;
  border-radius: 8px;
}
.category-item:hover {
  background: #f0f0f0;
  color: #ff6f00;
}
.cat-icon {
  font-size: 20px;
}

/* Hero banner */
.hero-banner {
  background: linear-gradient(135deg, #ff8f00 0%, #ff6f00 100%);
  padding: 50px 0;
}
.hero-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.hero-text h1 {
  font-size: 42px;
  color: white;
  margin: 10px 0;
}
.hero-text p {
  font-size: 18px;
  color: rgba(255, 255, 255, 0.9);
  margin-bottom: 20px;
}
.hero-badge {
  background: rgba(255, 255, 255, 0.2);
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  color: white;
}
.hero-btn {
  background: white;
  color: #ff6f00;
  border: none;
  padding: 12px 28px;
  border-radius: 8px;
  font-weight: bold;
  cursor: pointer;
}
.hero-stats {
  display: flex;
  gap: 20px;
}
.stat {
  background: rgba(255, 255, 255, 0.15);
  padding: 10px 20px;
  border-radius: 30px;
  color: white;
  font-size: 14px;
}

/* Products */
.products-section {
  padding: 50px 0;
}
.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}
.section-header h2 {
  font-size: 24px;
}
.see-all {
  color: #ff6f00;
  text-decoration: none;
}

.products-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 25px;
}
.product-card {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.3s;
  position: relative;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}
.product-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
}
.product-badge {
  position: absolute;
  top: 12px;
  left: 12px;
  background: #ff6f00;
  color: white;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: bold;
  z-index: 1;
}
.product-img {
  background: #fafafa;
  text-align: center;
  padding: 40px;
  font-size: 60px;
}
.product-info {
  padding: 16px;
}
.product-info h3 {
  font-size: 15px;
  margin-bottom: 10px;
  color: #333;
}
.price-row {
  margin-bottom: 8px;
}
.current-price {
  font-size: 22px;
  font-weight: bold;
  color: #ff6f00;
}
.old-price {
  font-size: 14px;
  text-decoration: line-through;
  color: #999;
  margin-left: 8px;
}
.rating {
  color: #ffc107;
  font-size: 13px;
  margin-bottom: 6px;
}
.rating span {
  color: #999;
  margin-left: 5px;
}
.shipping {
  font-size: 12px;
  color: #4caf50;
  margin-bottom: 12px;
}
.add-btn {
  width: 100%;
  background: #ff6f00;
  color: white;
  border: none;
  padding: 10px;
  border-radius: 8px;
  cursor: pointer;
  font-weight: bold;
}
.add-btn:hover {
  background: #e66500;
}

/* Brands */
.brands-section {
  background: white;
  padding: 30px 0;
  border-top: 1px solid #e0e0e0;
  border-bottom: 1px solid #e0e0e0;
}
.brands-grid {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 20px;
}
.brand-item {
  font-size: 14px;
  font-weight: bold;
  color: #666;
  letter-spacing: 1px;
}

/* Footer */
.footer {
  background: #1a1a1a;
  color: #999;
  padding: 40px 0 20px;
}
.footer-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 40px;
  margin-bottom: 30px;
}
.footer-grid h4 {
  color: white;
  margin-bottom: 15px;
}
.footer-grid a {
  display: block;
  color: #999;
  text-decoration: none;
  font-size: 13px;
  margin-bottom: 8px;
}
.footer-grid a:hover {
  color: #ff6f00;
}
.footer-bottom {
  text-align: center;
  padding-top: 20px;
  border-top: 1px solid #333;
  font-size: 12px;
}

/* ========== CARRITO FLOTANTE (ESQUINA INFERIOR DERECHA) ========== */
.cart-floating {
  position: fixed;
  bottom: 30px;
  right: 30px;
  background: #ff6f00;
  border-radius: 60px;
  padding: 12px 20px;
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  z-index: 999;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
  transition: transform 0.2s;
}
.cart-floating:hover {
  transform: scale(1.05);
}
.cart-icon-big {
  font-size: 28px;
  position: relative;
}
.cart-badge-big {
  position: absolute;
  top: -10px;
  right: -12px;
  background: white;
  color: #ff6f00;
  border-radius: 50%;
  padding: 2px 7px;
  font-size: 12px;
  font-weight: bold;
  min-width: 22px;
  text-align: center;
}
.cart-total-preview {
  background: white;
  color: #ff6f00;
  padding: 6px 14px;
  border-radius: 30px;
  font-weight: bold;
  font-size: 16px;
}

/* Modales */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
.modal-container {
  background: white;
  border-radius: 16px;
  max-width: 550px;
  width: 90%;
  max-height: 80vh;
  overflow-y: auto;
}
.modal-pago {
  max-width: 600px;
}
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 22px;
  border-bottom: 1px solid #eee;
}
.modal-close {
  background: none;
  border: none;
  font-size: 22px;
  cursor: pointer;
  color: #999;
}
.modal-body {
  padding: 22px;
}
.empty-cart-modal {
  text-align: center;
  padding: 50px;
}
.empty-cart-modal div {
  font-size: 60px;
  margin-bottom: 15px;
}
.btn-continue {
  background: #ff6f00;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 8px;
  cursor: pointer;
}

.cart-item-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 0;
  border-bottom: 1px solid #eee;
  flex-wrap: wrap;
  gap: 12px;
}
.cart-item-name {
  font-weight: bold;
  font-size: 14px;
}
.cart-item-price {
  font-size: 12px;
  color: #ff6f00;
  margin-top: 4px;
}
.cart-item-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}
.qty-btn {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 1px solid #ddd;
  background: white;
  cursor: pointer;
}
.qty-num {
  min-width: 25px;
  text-align: center;
}
.remove-item {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 18px;
}
.cart-item-subtotal {
  font-weight: bold;
  min-width: 80px;
  text-align: right;
}
.cart-total-section {
  text-align: right;
  padding: 18px 0;
  font-size: 20px;
  border-top: 2px solid #eee;
  margin-top: 10px;
}
.btn-checkout,
.btn-pay {
  width: 100%;
  background: #ff6f00;
  color: white;
  border: none;
  padding: 14px;
  border-radius: 10px;
  cursor: pointer;
  font-weight: bold;
  font-size: 16px;
  margin-top: 15px;
}

.order-resumen {
  background: #f5f5f5;
  padding: 15px;
  border-radius: 12px;
  margin-bottom: 20px;
}
.order-line {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
}
.order-total-line {
  display: flex;
  justify-content: space-between;
  padding-top: 10px;
  margin-top: 10px;
  border-top: 1px solid #ddd;
}
.total-amount {
  color: #ff6f00;
  font-size: 18px;
}
.input-field {
  width: 100%;
  padding: 12px;
  margin-bottom: 12px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 14px;
}

.toast-notification {
  position: fixed;
  bottom: 100px;
  right: 30px;
  background: #28a745;
  color: white;
  padding: 12px 20px;
  border-radius: 8px;
  z-index: 1001;
  animation: slideIn 0.3s ease;
}
@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateX(50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@media (max-width: 768px) {
  .header-row {
    flex-direction: column;
  }
  .search-wrapper {
    max-width: 100%;
    width: 100%;
  }
  .hero-content {
    flex-direction: column;
    text-align: center;
    gap: 20px;
  }
  .hero-stats {
    justify-content: center;
  }
  .cart-floating {
    bottom: 20px;
    right: 20px;
    padding: 8px 15px;
  }
  .cart-total-preview {
    font-size: 14px;
  }
}
</style>
